import React from 'react';

import { useIntl } from 'react-intl';

import { LoyaltyRewards } from 'pages/loyalty/loyalty-rewards';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

const LoyaltyRewardsListWidget = () => {
  const { formatMessage } = useIntl();

  const enableRewardPageStandAlone = useFlag(LaunchDarklyFlag.ENABLE_REWARD_PAGE_STAND_ALONE);

  return (
    <LoyaltyRewards
      isWidget={!enableRewardPageStandAlone}
      title={formatMessage({ id: 'redeemRewards' })}
    />
  );
};

export default LoyaltyRewardsListWidget;
